import { isOnlyLocationChange } from '../domain/search/isOnlyLocationChange'
import { isNonEmptyString, isNonEmptyObject, isNumber } from '../utils/checks'
import shouldUseLocation from '../domain/search/shouldUseLocation'
import { MILE_IN_METERS } from '../utils/computeMilesToMeters'
import { navigateToBrowsePageWithQueryParams } from '../domain/search/navigateToBrowsePageWithQueryParams'

const onSearchChange = async (state) => {
  let parentLocation = state?.parentLocation || ''

  const refinementListLocations = [
    state?.refinementList?.locations,
    parentLocation
  ].filter(Boolean)

  let locationName =
    state?.locationName || refinementListLocations.flat().join(', ')
  let aroundLatLng = state?.configure?.aroundLatLng
  let aroundRadius = state?.configure?.aroundRadius
  let aroundPrecision = state?.configure?.aroundPrecision
  let customLocationRadiusInMiles = state?.customLocationRadiusInMiles
  let locations = state?.refinementList?.locations || []

  const configure = state?.configure

  if (isOnlyLocationChange({ state })) {
    aroundLatLng = null
    aroundRadius = null
    aroundPrecision = null
    customLocationRadiusInMiles = null

    const locationChangeState = {
      configure,
      refinementList: {
        ...state.refinementList,
        locations
      },
      locationType: state?.locationType
    }

    await navigateToBrowsePageWithQueryParams(locationChangeState)
    return
  }
  configure.filters = isNonEmptyString(parentLocation)
    ? configure.filters.concat(` AND `, `locations:${parentLocation}`)
    : configure.filters

  if (isNonEmptyObject(state?.refinementList) && shouldUseLocation(state)) {
    const taxonomyChangeState = {
      configure,
      refinementList: {
        ...state.refinementList,
        locations
      },
      locationType: state?.locationType
    }

    await navigateToBrowsePageWithQueryParams(taxonomyChangeState)
    return
  }
  const searchRadius = {
    aroundRadius,
    aroundPrecision
  }

  if (
    isNumber(state?.customLocationRadiusInMiles) &&
    state?.customLocationRadiusInMiles > 0
  ) {
    searchRadius.aroundRadius = parseInt(
      MILE_IN_METERS * state.customLocationRadiusInMiles
    )

    searchRadius.aroundPrecision = parseInt(
      MILE_IN_METERS * state.customLocationRadiusInMiles
    )
  }

  const facetSearchState = {
    locationName,
    configure: {
      ...configure,
      aroundLatLng,
      ...searchRadius
    },
    refinementList: {
      ...state.refinementList,
      locations: []
    },
    customLocationRadiusInMiles:
      isNumber(state.customLocationRadiusInMiles) &&
      state.customLocationRadiusInMiles > 0
        ? state.customLocationRadiusInMiles
        : null,
    locationType: state?.locationType
  }

  await navigateToBrowsePageWithQueryParams(facetSearchState)
}

export default onSearchChange
